<template>
    <div v-cloak>
        <b-table
            small
            striped
            responsive
            outline
            :fields="element_fields"
            :items="elements"
        >
            <template
                slot="result"
                slot-scope="row"
            >
                <b-dropdown
                    :id="'result-' + row.item.id"
                    :text="row.item.result || 'E'"
                    :no-caret="true"
                    variant="outline-secondary"
                    size="sm"
                    toggle-class="rounded"
                    :disabled="getOptions(resultOpts, row.item.result).length === 0"
                >
                    <b-dropdown-item-button
                        v-for="r in getOptions(resultOpts, row.item.result)"
                        :key="row.item.id + '-' + r"
                        @click="updateResult(row.item, r)"
                    >
                        {{ r }}
                    </b-dropdown-item-button>
                </b-dropdown>
            </template>

            <template
                slot="result_start_date"
                slot-scope="row"
            >
                <enrolment-date-component
                    :enrolment-id="Number(row.item.id)"
                    :code="row.item.code"
                    :old-value="row.item.result_start_date"
                    field-name="Start_Date"
                    description="Actual Start Date"
                    @refreshData="refreshData(row.item)"
                />
            </template>

            <template
                slot="result_end_date"
                slot-scope="row"
            >
                <enrolment-date-component
                    :enrolment-id="Number(row.item.id)"
                    :code="row.item.code"
                    :old-value="row.item.result_end_date"
                    field-name="Finish_Date"
                    description="Actual End Date"
                    @refreshData="refreshData(row.item)"
                />
            </template>
        </b-table>
    </div>
</template>

<script>
import EnrolmentDateComponent from './EnrolmentDateComponent.vue';

export default {
    name: 'PartOneElements',
    components: {
        EnrolmentDateComponent,
    },
    props: {
        code: {
            type: String,
            required: true,
        },
        enrolmentId: {
            type: Number,
            required: true,
        },
        elements: {
            type: Array,
            required: true,
        },
        competencyResult: {
            type: String,
            default: '',
        },
    },
    data() {
        let resultOpts = ['E', 'Ex', 'P'];
        if (['ATT', 'PO', 'COM'].includes(this.competencyResult)) {
            resultOpts = ['E', 'P'];
        }
        return {
            element_fields: [
                { key: 'element_code' },
                { key: 'title' },
                { key: 'hours' },
                { key: 'result' },
                { key: 'result_start_date' },
                { key: 'result_end_date' },
            ],
            resultOpts,
        };
    },
    validations: {},
    computed: {},
    methods: {
        getOptions(options, currentResult) {
            // find index of currentResult if set
            if (currentResult === 'Ex' || currentResult === 'EX') {
                return [];
            }
            if (currentResult !== '') {
                const index = options.indexOf(currentResult);
                if (index !== -1) {
                    return options.slice(index + 1);
                }
            }
            return options;
        },
        refreshData(row) {
            this.$emit('refreshData', row.competency_row_id);
        },
        updateResult(row, result) {
            this.$emit('updateElement', row, result);
        },
    },
};
</script>
